export const conceptsContent = `# Concepts

* **App (\`appSlug\`)** – The product instance defined in Lightswitch.
* **Publishable Key** – Safe for the browser; identifies your app to Lightswitch.
* **Entitlement (\`has_access\`)** – Boolean gate tied to a user + app; usually granted via SKU purchase.
* **Paywall** – A modal the SDK can auto-show when a \`ProtectedRoute\` detects no entitlement.
* **Supabase Session** – The SDK reads the current session from your supplied \`supabaseClient\`.

**How entitlement checks work**

1. Read Supabase session.
2. Exchange for a Lightswitch user context.
3. Call **Entitlement Check** for the app's \`has_access\`.
4. If **true** → render content.
5. If **false** → show **paywall** (if \`autoShowPaywall\` is enabled); sign-in/sign-up/checkout can grant access, then content renders.`;
